import React, { useMemo } from 'react';
import MultiForm from './multiForm';
import { useAcquisitionType } from '../../hooks/stateful/useAcquisitionType';

const AcquisitionForm = () => {
  const { acquisitionType, acquisitionViewStack } = useAcquisitionType();
  const acquisitionFormType = useMemo(
    () => acquisitionViewStack[acquisitionViewStack.length - 1],
    [acquisitionViewStack]
  );

  return (
    <div data-testid="acquisitionFormContainer">
      <MultiForm
        acquisitionType={acquisitionType}
        acquisitionFormType={acquisitionFormType}
      />
    </div>
  );
};

export default AcquisitionForm;
